import { createServerFn } from "@tanstack/react-start";
import { listTrainingCatalog } from "../../../api/src/training/catalog";
import { listTrainingDrafts } from "../../../api/src/training/authoring";
import { trainingDiscoveryItem } from "../../../shared/src/training-logic";
import { siteContext, privateResponse } from "./site.server";
import { composedServicePage } from "./services.server";

export const loadTraining = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  privateResponse();
  if (!drate.creator) return { kind: "missing" as const };
  if (drate.customizationPreview) {
    const drafts = drate.templatePreview ? [] : await listTrainingDrafts(drate, drate.creator.id);
    return {
      kind: "native" as const,
      preview: true,
      catalog: {
        title: "Training",
        intro: "Your workouts, programs and progress, together.",
        signedIn: false,
        items: drafts.map((row) => trainingDiscoveryItem(row.id, row.data, false)),
      },
    };
  }
  const catalog = await listTrainingCatalog(drate);
  const page = await composedServicePage(drate, "/training");
  if (page.kind === "redirect") return page;
  if (page.kind === "page") return { ...page, preview: false, catalog };
  return { kind: "native" as const, preview: false, catalog };
});
